import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '../icons'

const GoldBarsOutlined = ({
  size = 24,
  color = '#fff',
  ...props
}: IconProps) => (
  <Svg width={size} height={size} viewBox="0 0 20 20" fill="none" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8001 2.5002C10.8001 2.05837 10.4419 1.7002 10.0001 1.7002C9.55823 1.7002 9.20006 2.05837 9.20006 2.5002V5.0002C9.20006 5.44202 9.55823 5.8002 10.0001 5.8002C10.4419 5.8002 10.8001 5.44202 10.8001 5.0002V2.5002ZM7.47378 6.7002C6.87725 6.7002 6.35727 7.10618 6.21259 7.6849L5.20877 11.7002H3.30711C2.71059 11.7002 2.19061 12.1062 2.04593 12.6849L0.968269 16.9955C0.802593 17.6582 1.30382 18.3002 1.98692 18.3002H8.97544H10.0001H11.0247H14.1667H18.0132C18.6963 18.3002 19.1975 17.6582 19.0318 16.9955L17.9542 12.6849C17.8095 12.1062 17.2895 11.7002 16.693 11.7002H14.7913L13.7875 7.6849C13.6428 7.10618 13.1229 6.7002 12.5263 6.7002H7.47378ZM10.2254 13.3002L10.0001 14.2017L9.77468 13.3002H10.2254ZM13.1421 11.7002H11.6404H8.35967H6.85801L7.70801 8.3002H12.2921L13.1421 11.7002ZM11.0247 16.7002L11.8747 13.3002H13.8465H16.4588L17.3088 16.7002H14.1667H11.0247ZM8.12544 13.3002H6.15359H3.54135L2.69135 16.7002H8.97544L8.12544 13.3002ZM4.58846 2.64753C4.96733 2.42022 5.45873 2.54307 5.68605 2.92193L6.93605 5.00527C7.16337 5.38413 7.04052 5.87554 6.66165 6.10286C6.28279 6.33017 5.79138 6.20732 5.56406 5.82846L4.31406 3.74513C4.08675 3.36626 4.2096 2.87485 4.58846 2.64753ZM14.3141 2.92193C14.5414 2.54307 15.0328 2.42022 15.4117 2.64753C15.7905 2.87485 15.9134 3.36626 15.6861 3.74513L14.4361 5.82846C14.2087 6.20732 13.7173 6.33017 13.3385 6.10286C12.9596 5.87554 12.8367 5.38413 13.0641 5.00527L14.3141 2.92193Z"
      fill={color}
    />
  </Svg>
)

export default GoldBarsOutlined
